import type * as models from '../models'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State<TItem extends models.Item<unknown> = models.Item<any>> {}
export namespace State {
  export const INITIAL: State = {}
}
